import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
class ConfirmOrder extends React.Component {
  handleConfirm = event => {
    event.preventDefault();
    this.context.router.history.push("/dashboard/orderhistory");
  };
  render() {
    const order = this.props.orderPayload;
    const transaction = order.paypal.transactions[0].amount;
    const useType = order.item.useType;
    /*let plan;
    if (useType === "USA") {
      plan = "USA Plan";
    }
    if (useType === "GLOBAL") {
      plan = "Global Plan";
    }*/
    const autoRenewal = order.autoRenewal;
    //const renewalStartDate = moment(order.cart.startDate.substring(0, 10)).add(order.cart.recurring_profile.period, "days").format("MM/DD/YYYY");
    //const nextRechargeDate = moment(order.cart.startDate.substring(0, 10)).add(order.cart.recurring_profile.period - 1, "days").format("MM/DD/YYYY"); //error! rent doesn't have period

    console.log("props", this.props);
    return (
      <div className="col-md-8 services_clip ">
        <div className="">
          <div className="row">
            <div className="col-lg-12">
              <div className="services_boxes">
                <div className="services_content">
                  <h3 className="mb-0">Thank you for choosing {order.product.name}!</h3>
                  <p>We hope you have a good time.</p>
                  <div style={{ clear: "both", height: "15px" }} />

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group mt-3">
                        <p className="mb-0 mt-2">
                          Your order number is{" "}
                          <span className="bold600">
                            <Link
                              to={`/dashboard/order/${
                                  order.orderId
                              }`}
                            >
                              {order.orderId}
                            </Link>
                          .</span>
                        </p>
                      </div>

                      <div style={{ clear: "both", height: "15px" }} />

                      <h4 className="SansSerif bold100 mb-3">{order.product.name}<br/>
                      {
                        (order.product.color !== null) ? (
                            <h5 className="bold600 mt-3"> {order.product.color}</h5>
                        ) : null
                      }
                      </h4>

                      {
                        (order.item.cartType === 'device' && order.cart.recurring_profile !== null) ? (
                            <h5 className="SansSerif"> {(useType === "GLOBAL" && typeof order.cart.country !== "undefined" && order.cart.country !== null) ? order.cart.country.name + " " + order.cart.recurring_profile.name : useType + " " + order.cart.recurring_profile.name}</h5>
                        ) : null
                      }

                      <p className="mb-2">{order.product.shortDescription}</p>

                      <div style={{ clear: "both", height: "15px" }} />

                      {/*<p className="mb-2">{order.item.cartType !== 'sim' && plan}</p>*/}
                      {
                        (order.item.startDate !== null) ? (
                            <p className="mb-2">
                              Start Date:{" "}
                              <span>
                              {moment(order.item.startDate.substring(0, 10)).format(
                                  "MM/DD/YYYY"
                              )}
                              </span>
                            </p>

                        ) : null
                      }
                      {
                        (order.item.endDate !== null) ? (
                            <p className="mb-2">
                              End Date:{" "}
                              <span>
                              {moment(order.item.endDate.substring(0, 10)).format(
                              "MM/DD/YYYY"
                              )}
                              </span>
                            </p>

                        ) : null
                      }

                      <div style={{ clear: "both", height: "15px" }} />
                      
                      <p className="mb-2">
                        Sub Total: {" "}
                        {
                          (typeof order.after_discount_totals_flat !== "undefined" && order.after_discount_totals_flat !== null && typeof order.after_discount_totals_flat.grandTotal !== "undefined"  && order.after_discount_totals_flat !== null) ? (
                              <span className="mb-2">
                                <span style={{textDecoration: "line-through"}}>
                                  ${parseFloat(order.cart.subtotal).toFixed(2)}
                                </span>&nbsp;
                                <span>
                                  ${parseFloat(order.after_discount_totals_flat.grandTotal).toFixed(2)}
                                </span>
                              </span>
                          ):
                              <span className="mb-2">
                                ${parseFloat(order.cart.subtotal).toFixed(2)}
                              </span>
                        }
                        </p>

                        { order.item.cartType !== 'device_recharge' ?
                            (
                                <p className="mb-2">
                                  Shipping Fee: {" "}
                                  <span>
                                    {parseFloat(order.cart.shippingFee).toFixed(2) == 0 ? "Free" : "$" + parseFloat(order.cart.shippingFee).toFixed(2)}
                                  </span>
                                </p>
                          ) : null
                        }

                        <p className="mb-2">
                        Tax: {" "}
                          <span>
                          {parseFloat(order.cart.tax).toFixed(2) == 0 ? "Included" : "$" + parseFloat(order.cart.tax).toFixed(2)}
                          </span>
                        </p>

                      <p className="mb-2">
                        Total: <span className="bold600">${parseFloat(transaction.total).toFixed(2)}</span>
                      </p>

                      {/*{ autoRenewal ?
                          (
                              <div>
                                <div style={{ clear: "both", height: "20px" }} />
                                <div>
                                  <h4 className="mb-0">AUTO PAY is active.</h4>
                                  <h4 className="mb-0">Next recharge date: {nextRechargeDate}</h4>
                                </div>
                              </div>
                          ) : null
                      }*/}
                    </div>
                  </div>

                  <div style={{ clear: "both", height: "30px" }} />

                  { order.item.cartType === 'sim' ?

                      (
                    <p className="text-center">
                        When you receive your SIM, activate it here at <a href="/activate/sim">www.MightyWifi.net/activate/sim</a>
                    </p>
                    ) : null
                  }

                    <div style={{ clear: "both", height: "15px" }} />

                  <a
                    href="javascript:void(0)"
                    onClick={this.handleConfirm}
                    className="btn btn-orange"
                  >
                    MY ACCOUNT
                  </a>

                  <div style={{ clear: "both", height: "100px" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
ConfirmOrder.contextTypes = {
  router: PropTypes.object.isRequired
};

export default ConfirmOrder;



// WEBPACK FOOTER //
// ./src/pages/checkout/ConfirmOrder.js